export default __webpack_public_path__ + "static/media/flanksource-icon.aad9535a.svg";